const colors = {
  primaryGreen: "#B4D6D3",
  primaryDarkGreen: "#95BAB7",
  secondaryPink: "#F5BBB3",
  secondaryLightPink: "#f7cdc8",
  darkBlue: "#203A4C",
  lightGrey: "#EAEAEB",
};

export default colors;
